angular.module('gym.registration', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.registration', {
    url: '^/users?gymId'
  }).state('gym.registration.edit', {
    url: '/edit'
  });
}]);
